﻿(function () {
    'use strict';
    var controllerId = 'dirMenuBar2Ctrl';
    angular
        .module('app.controllers')
    .controller(controllerId, dirMenuBar2Ctrl)
      
    dirMenuBar2Ctrl.$inject = ['common', 'datacontext', '$http', '$scope', '$state', '$stateParams', '$translate', '$window'];

    function dirMenuBar2Ctrl(common, datacontext, $http, $scope, $state, $stateParams, $translate, $window) {

        var vm;
        vm = this;
        vm.getMenuBarConfig = getMenuBarConfig;
        vm.goHome = goHome;
        vm.menuInfo = [];
        vm.menuGroups = [];

        init();

        function init() {
            common.activateController([getMenuBarConfig()])
              .then(function (data) {
                  
                  loadMenuBarData(data);
              });
        }

        function getMenuBarConfig() {

            var authData = common.localStorageService.get('authorizationData');
            if (authData != null && authData.username != null) {
                
                //var oldReponse =  datacontext.security.getMenuBar();
                var newResponse = common.localStorageService.get('GetMenuBarQuery');
                return newResponse;
            } else {
               // toastr.info("No se pudieron recuperar los datos del menu");
            }

        }

        function loadMenuBarData(data) {

            
            //vm.menuInfo = data;
            vm.menuInfo = [];
            vm.menuInfo.push({ data: common.localStorageService.get('GetMenuBarQuery') });
            
            for (var m in vm.menuInfo)
            {
                //if (vm.menuInfo[m].data) {
                //    vm.menuGroups.push(vm.menuInfo[m].data[0]);
                //}
                for (var n in vm.menuInfo[m].data) {
                    if (vm.menuInfo[m].data[n]) {
                        vm.menuGroups.push(vm.menuInfo[m].data[n]);
                    }
                }
            }

            vm.menuGroups = vm.menuGroups;

        }

        $scope.scheduler = function scheduler(Type) {            

            switch(Type)
            {
                case 'D':                    
                    $window.sessionStorage.type = Type;                    
                    $state.go("root.appointmentMainApptSchedule", $stateParams, { reload: false, inherit: false, notify: true });                    
                    break;
                case 'P':                    
                    $window.sessionStorage.type = Type;
                    $state.go("root.appointmentMainApptSchedule2", $stateParams, { reload: false, inherit: false, notify: true });                    
                    break;
            }
        }

        function goHome() {
            $state.go('root');
        }

    }
})();        